import { css, keyframes } from 'emotion';

const zoom = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

export const activityBody = css`
  padding: 16px 22px 0px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: scroll;

  & > :first-child {
    margin-top: auto !important;
  }
`;

export const messageContainer = css`
  animation-duration: 1s;
  animation-name: ${zoom};
  max-width: 100%;
  margin: 9px 0px;
  width: max-content;
`;

export const notification = theme => css`
  background: ${theme.color.grey4};
  line-height: 20px;
  padding: 8px 10px;
  border-radius: 4px;
  color: ${theme.color.black1};
`;

export const bold = css`
  font-weight: bold;
`;

export const chat = (theme, isSelf) => css`
  background: ${isSelf ? theme.color.accent : theme.color.accentHighlight};
  color: ${isSelf ? 'white' : theme.color.black1};
  padding: 10px;
  border-radius: 4px;
  display: flex;
`;

export const timeStamp = css`
  font-size: 12px;
  margin: 2px 0px 0px 8px;
`;

export const chatImage = css`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
`;

export const chatDetails = css`
  display: flex;
  flex-direction: column;
  margin-left: 13px;
`;

export const chatName = (theme, isSelf) => css`
  text-transform: uppercase;
  letter-spacing: 0.9px;
  font-size: 12px;
  font-weight: 600;
  color: ${isSelf ? '#fff' : theme.color.black3};
  margin-bottom: 2px;
`;

export const chatText = css`
  line-height: 1.5;
  font-size: 16px;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const loaderContainer = css`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
